<script>
  import { zhouyitw, zhouyicn } from "../etc/zhouyi.js"
  import { selectedLanguage } from "../etc/store.js"
  export let numStr
  export let gua_code
  //$: console.log("@ ShowGuaText: Got numStr: " + numStr)

  let zhouyi = zhouyitw
  $: if ($selectedLanguage == "TW") {
    zhouyi = zhouyitw
  } else {
    zhouyi = zhouyicn
  }

  let showGuaText = false
  $: numStr.length != 0 ? (showGuaText = true) : (showGuaText = false)

  //$: console.log("@ ShowGuaText: gua_code = " + gua_code)
</script>

<div class=" guatext">
  {#if showGuaText}
    <table class="striped">
      <tbody>
        <tr>
          <td>{zhouyi[gua_code].gua}</td>
        </tr>
        <tr>
          <td>{zhouyi[gua_code].tuan}</td>
        </tr>
        <tr>
          <td>{zhouyi[gua_code].xiang}</td>
        </tr>
        {#if gua_code == "111111"}
          <tr>
            <td>{zhouyi[gua_code].yong9}</td>
          </tr>
        {:else if gua_code == "000000"}
          <tr>
            <td>{zhouyi[gua_code].yong6}</td>
          </tr>
        {/if}
      </tbody>
    </table>
  {/if}
</div>

<style></style>
